import { inresiHttpService } from "utils/http";

import {
  type BootstrapData,
  type BootstrapResponse,
  BootstrapResponseSchema,
} from "../schemas";

export type { BootstrapData, BootstrapResponse };

export async function fetchBootstrap(
  slug: string,
  visitorId: string
): Promise<BootstrapData> {
  const res = await inresiHttpService.get<BootstrapResponse>(
    `embed/${slug}/bootstrap/${visitorId}`,
    { schema: BootstrapResponseSchema }
  );
  return res.data;
}
